import styled from "styled-components";

export const AboutPageContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin-inline: auto;
  padding: 50px 100px;
`;
